import { Flex, Span, PopOver, styled } from '@fareye/ui'
import { FaThermometerThreeQuarters, isEmpty } from '@fareye/utils'
import { parseTemperature, useTranslation } from '@fareye/common'
import React from 'react'
import ReactTooltip from 'react-tooltip'
import intransitColors from '../../../config/colors'
import { inTransitConstant } from '../../../config/constants'

const TemperatureToolTipContainer = styled(ReactTooltip)`
  filter: drop-shadow(0px 6.4px 13.4px rgba(47, 60, 69, 0.13))
    drop-shadow(0px 4.8px 3.6px rgba(47, 60, 69, 0.1));
`
const ToolTipContentWrapper = styled(Flex)`
  align-items: flex-start;
  padding: 0px 0px 4px 4px;
  gap: 4px;
  ${(props: any) => `color: ${props.color ? props.color : '#212121'};`}
`
const {
  temperatureContent: temperatureContentColor,
  temperatureToolTipBackground: temperatureToolTipBackgroundColor
} = intransitColors['temperatureToolTip']
const TemperatureToolTip = (props: any) => {
  const { isWithinRange, temperatureMin, temperatureMax, t } = props
  return (
    <Flex column>
      <ToolTipContentWrapper
        color={
          isWithinRange
            ? temperatureContentColor['withinRange']
            : temperatureContentColor['outsideRange']
        }
      >
        {isWithinRange
          ? t(inTransitConstant['toolTipWithinRangeContent'])
          : t(inTransitConstant['toolTipOutsideRangeContent'])}
      </ToolTipContentWrapper>
      <ToolTipContentWrapper>
        <FaThermometerThreeQuarters size={14} style={{ marginRight: '-2px' }} />
        {t(inTransitConstant['tempRange'])} {`${temperatureMin}`}&#8451;{' '}
        {t(inTransitConstant['to'])} {`${temperatureMax}`}
        &#8451;
      </ToolTipContentWrapper>
    </Flex>
  )
}
export default function Temperature({ data = {}, id }: any) {
  // check if data exists and has keys: 'temperature or sensorData', return if condition not satisfied
  let isEmptyExtraInfo =
    isEmpty(data) ||
    !(data?.hasOwnProperty('temperature') || data?.hasOwnProperty('sensorData'))

  if (isEmptyExtraInfo) {
    return null
  }

  let temperatureLabel: any = parseTemperature(
    data?.temperature ?? data?.sensorData
  )
  // return if temperature not received in adequate format. Adequate format: number or string of number
  if (!temperatureLabel) {
    return null
  }

  let temperature: any = Number(
    data?.temperature ?? data?.sensorData?.[0]?.temperature
  )
  let temperatureRange: number[] | [] =
    data?.temperatureMax && data?.temperatureMin
      ? [data?.temperatureMin, data?.temperatureMax]
      : []
  let color: string
  let isWithinRange: boolean = false
  if (!isEmpty(temperatureRange)) {
    //discussed with product two conditions, within and outside range.
    if (
      temperature >= Number(data?.temperatureMin) &&
      temperature <= Number(data?.temperatureMax)
    ) {
      color = temperatureContentColor['withinRange']
      isWithinRange = true
    } else {
      color = temperatureContentColor['outsideRange']
    }
  } else {
    color = temperatureLabel.includes('-')
      ? temperatureContentColor['withinRange']
      : temperatureContentColor['outsideRange']
  }
  const { t } = useTranslation()
  return (
    <>
      <Flex style={{ marginLeft: '6px' }} data-tip data-for={id}>
        <FaThermometerThreeQuarters
          size={14}
          color={color}
          style={{ marginRight: '2px' }}
        />
        {temperatureLabel && <Span>{temperatureLabel}&#8451;</Span>}
      </Flex>
      {!isEmpty(temperatureRange) && (
        <ReactTooltip
          place="top"
          effect="float"
          backgroundColor={
            isWithinRange
              ? temperatureToolTipBackgroundColor['withinRange']
              : temperatureToolTipBackgroundColor['outsideRange']
          }
          id={id}
        >
          <TemperatureToolTip
            isWithinRange={isWithinRange}
            temperatureMin={data?.temperatureMin}
            temperatureMax={data?.temperatureMax}
            t={t}
          />
        </ReactTooltip>
      )}
    </>
  )
}
